import React from "react";

const TableLiterasiSiswaPotensi = ({ dataLiterasi, isPotensi, hasSekolah }) => {

    let listData = []
    let label = hasSekolah ? 'Kelas' : 'Rata - rata'
    if (isPotensi) {
        listData = dataLiterasi.potensi
    } else {
        listData = dataLiterasi.darurat
    }
    require("./Ensa.css");
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '10px', padding: '20px', background: '#F9FAFB', border: '1px #E0E0E0 solid', borderRadius: '8px' }}>
            {listData.map((item, i) =>
                <div style={{width: '50%'}}>
                    <table className="table table-custom" id="rekap" key={i}>
                        <thead>
                            <tr>
                                <th className="th-title v-align-center" rowSpan="2" scope="col">
                                    No.
                                </th>
                                <th className="th-title v-align-center" rowSpan="2" scope="col">
                                    {item.key}
                                </th>
                                <th className="th-title v-align-center" rowSpan="2" scope="col">
                                    {label}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {item.value.map((item, i) =>
                                <tr key={i} style={{height: '65px'}}>
                                    <td align="center">{i + 1}</td>
                                    <td align="left">{item.key}</td>
                                    <td align="left" style={{paddingRight: '0px', paddingLeft: '4px'}}>{item.value}</td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>
            )}
        </div>

    );
};

export default TableLiterasiSiswaPotensi;
